import Base from './Base'
import Home from './Home'
import ComercioExterior from './ComercioExterior'
import BancaFiduciaria from './BancaFiduciaria'
import Garantias from './Garantias'
import CuentaCorriente from './CuentaCorriente'
import Pymes from './Pymes'
import Detail from './Detail'
import Elegirnos from './Elegirnos'
import Financiamiento from './Financiamiento'
import Contacto from './Contacto'
import QuienesSomos from './QuienesSomos'
import Talento from './Talento'
import Historias from './Historias'
import Legales from './Legales'
import Leasing from './Leasing'
import Mercado from './mercado'
import Colocaciones from './Colocaciones'
import Resumen from './Resumen'

export {
    Base,
    Home,
    BancaFiduciaria,
    ComercioExterior,
    Garantias,
    CuentaCorriente,
    Pymes,
    Detail,
    Elegirnos,
    Financiamiento,
    Contacto,
    QuienesSomos,
    Talento,
    Historias,
    Legales,
    Leasing,
    Mercado,
    Colocaciones,
    Resumen
}